import React from "react";
import videoSrc from "../../Assets/img/273921.mp4"; 

const VideoHeroAbout = () => {
  return (
    <section className="video-hero-about">
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="bg-video-about"
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Stats boxes */}
      <div className="stats-container px-2 About-Labels">
        <div className="stat-box stat1">
          <div className="stat-number">3000+</div>
          <div className="stat-label">Successful Placements</div>
        </div>
        <div className="stat-box stat2">
          <div className="stat-number">90%</div>
          <div className="stat-label">Retention Rate</div>
        </div>
      </div>
    </section>
  );
};

export default VideoHeroAbout;
